var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ds-modal", {
    attrs: { open: _vm.showModal },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "modal-dialog go-modal-url-form" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title" }, [
                    _c("em", [_vm._v(_vm._s(_vm.$t("scrap-agent.url.title")))]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleClose.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "go-tooltip-area",
                          attrs: { "data-toggle": "tooltip", title: "Close" },
                        },
                        [_c("i", { staticClass: "go-icon-20 go-icon-close" })]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-form-group" }, [
                    _c("label", { staticClass: "go-form-label" }, [
                      _vm._v("URL"),
                      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex", staticStyle: { gap: "10px" } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.formData.url,
                              expression: "formData.url",
                            },
                          ],
                          staticClass: "go-form-control",
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t("scrap-agent.url.address-pl"),
                          },
                          domProps: { value: _vm.formData.url },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleEnter.apply(null, arguments)
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.formData, "url", $event.target.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-outline-primary",
                            staticStyle: {
                              "min-width": "80px",
                              "justify-content": "center",
                            },
                            attrs: {
                              type: "button",
                              disabled:
                                _vm.formData.url.trim() == "" || _vm.isLoading,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleEnter()
                              },
                            },
                          },
                          [
                            _c("em", { staticClass: "go-text" }, [
                              _vm._v(_vm._s(_vm.$t("scrap-agent.check"))),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-form-group input-wrapper" }, [
                    _c("label", { staticClass: "go-form-label" }, [
                      _vm._v(_vm._s(_vm.$t("scrap-agent.url.channel-name"))),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.chanelName,
                          expression: "formData.chanelName",
                        },
                      ],
                      staticClass: "go-form-control",
                      attrs: {
                        type: "text",
                        placeholder: _vm.isLoading
                          ? ""
                          : _vm.$t("scrap-agent.url.channel-name-pl"),
                      },
                      domProps: { value: _vm.formData.chanelName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.formData,
                            "chanelName",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.isLoading && !_vm.formData.chanelName
                      ? _c("span", { staticClass: "placeholder-spinner" })
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-form-group textarea-wrapper" }, [
                    _c("label", { staticClass: "go-form-label" }, [
                      _vm._v(_vm._s(_vm.$t("scrap-agent.url.channel-intro"))),
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.channelIntro,
                          expression: "formData.channelIntro",
                        },
                      ],
                      staticClass: "go-form-control",
                      attrs: {
                        placeholder: _vm.isLoading
                          ? ""
                          : _vm.$t("scrap-agent.url.channel-intro-pl"),
                        rows: "3",
                      },
                      domProps: { value: _vm.formData.channelIntro },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.formData,
                            "channelIntro",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.isLoading && !_vm.formData.channelIntro
                      ? _c("span", {
                          staticClass: "placeholder-spinner",
                          staticStyle: { top: "38%" },
                        })
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-form-feedback" }, [
                    _c("div", { staticClass: "go-form-feedback-help" }, [
                      _vm._v("* " + _vm._s(_vm.$t("scrap-agent.url.note"))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-primary",
                      attrs: { type: "button", disabled: _vm.isDisableBtn },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleSubmit()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("scrap-agent.url.btn")) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }